export default __webpack_public_path__ + "static/wedding-rings-white-5f174ed48dc4c7e0ac1a55ae8302cc74.png";